module.exports = new __parcel__URL__("golden_pack.6f5fb47d.png").toString();